import React, { useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Alert,
    InputAdornment,
    IconButton,
    Link,
    CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { adminUserLogin } from "../../Apis/loginApi";
import { useNavigate } from "react-router-dom";

const LoginPage = ({onLogin}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [formType, setFormType] = useState("login");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [forgotEmail, setForgotEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        try {
            setLoading(true);
            const response = await adminUserLogin(email, password);
            const token = response?.token;


            if (token) {
                localStorage.setItem("token", token);
                 // ✅ consistent key
                setSuccess("Logged in successfully!");
              onLogin()

            }
           
        } catch (err) {
            setError(err.message || "Login failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!forgotEmail) {
            setError("Email is required.");
            return;
        }

        if (!validateEmail(forgotEmail)) {
            setError("Please enter a valid email.");
            return;
        }

        setSuccess("Password reset link has been sent!");
        setForgotEmail("");
    };

    const switchForm = (type) => {
        setError("");
        setSuccess("");
        setFormType(type);
    };

    return (
        <Box
            sx={{
                width: "100%",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    width: 360,
                    bgcolor: "white",
                    p: 4,
                    borderRadius: 2,
                    boxShadow: 3,
                    minHeight: "200px",
                }}
            >
                {formType === "login" ? (
                    <>
                        <Typography variant="h5" mb={3} textAlign="center">
                            Admin Login
                        </Typography>
                        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

                        <form onSubmit={handleLogin}>
                            <TextField
                                label="Email"
                                type="email"
                                fullWidth
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <TextField
                                label="Password"
                                type={showPassword ? "text" : "password"}
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                sx={{ mb: 2 }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleTogglePassword} edge="end">
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                sx={{ mb: 1 }}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={24} /> : "Login"}
                            </Button>
                        </form>

                        <Typography variant="body2" textAlign="center">
                            <Link href="#" onClick={() => switchForm("forgot")}>
                                Forgot Password?
                            </Link>
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography variant="h5" mb={3} textAlign="center">
                            Forgot Password
                        </Typography>
                        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

                        <form onSubmit={handleForgotPassword}>
                            <TextField
                                label="Email"
                                type="email"
                                fullWidth
                                value={forgotEmail}
                                onChange={(e) => setForgotEmail(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <Button type="submit" variant="contained" fullWidth sx={{ mb: 1 }}>
                                Send Reset Link
                            </Button>
                        </form>

                        <Typography variant="body2" textAlign="center">
                            <Link href="#" onClick={() => switchForm("login")}>
                                Back to Login
                            </Link>
                        </Typography>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default LoginPage;
